import { Base } from '../../abstract/base.model';
import { nullableDecimal, nullableString } from '../utils/wire-value-utils';
import { isRecord } from '../utils/is-record';
import { DisputeReasonCode } from './dispute-reason-code.model';
import { DisputeResolutionType } from './dispute-resolution-type.model';
import { DisputeStatus } from './dispute-status.model';

/**
 * A farmer-filed payment dispute as `/admin/disputes` returns it (hub `admin-disputes-controller.ts`), built to the
 * agreed `ADMIN_DISPUTE_READABLE` list. Initiator / resolver profile and org ids are deliberately not mapped.
 *
 * Read-only: disputes change only through POST /admin/disputes/:id/resolve. Unsent fields stay `undefined`,
 * `null` stays `null`. `resolutionAmount` is dollars; `resolvedAt` stays an ISO string.
 */
export class Dispute extends Base {
  paymentId?: string | null;
  jobId?: string | null;
  reasonCode?: DisputeReasonCode | null;
  description?: string | null;
  status?: DisputeStatus | null;
  resolutionType?: DisputeResolutionType | null;
  resolutionAmount?: number | null;
  resolutionNotes?: string | null;
  resolvedAt?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.paymentId = nullableString(source['paymentId']);
    this.jobId = nullableString(source['jobId']);
    this.reasonCode = nullableString(source['reasonCode']) as DisputeReasonCode | null | undefined;
    this.description = nullableString(source['description']);
    this.status = nullableString(source['status']) as DisputeStatus | null | undefined;
    this.resolutionType = nullableString(source['resolutionType']) as DisputeResolutionType | null | undefined;
    this.resolutionAmount = nullableDecimal(source['resolutionAmount']);
    this.resolutionNotes = nullableString(source['resolutionNotes']);
    this.resolvedAt = nullableString(source['resolvedAt']);
  }
}
